import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";

import { Checkbox, FormControlLabel, Paper } from "@mui/material";
import Grid from "@mui/material/Grid";

import { ReturnableTypeEnum } from "@/features/purchase-returns";
import { OutletWarehouseSelect } from "@/features/warehouses";

export const OtherSection = ({ editMode = false }) => {
  const { control, watch } = useFormContext();

  const buyer = watch("buyer");
  const returnableType = watch("returnableType");

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Grid container spacing={2.5}>
        {returnableType === ReturnableTypeEnum.NON_INVOICE && (
          <Grid size={12}>
            <Controller
              control={control}
              name="warehouse"
              render={({ field, fieldState }) => (
                <OutletWarehouseSelect
                  outletId={buyer?.id}
                  value={field.value}
                  onChange={field.onChange}
                  disabled={!buyer}
                  TextFieldProps={{
                    label: "Gudang",
                    required: true,
                    error: fieldState.invalid,
                    helperText: fieldState.error?.message,
                  }}
                />
              )}
            />
          </Grid>
        )}
        <Grid container spacing={1}>
          <Grid>
            <Controller
              name="taxable"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={field.value || false}
                      onChange={(e) => field.onChange(e.target.checked)}
                      disabled={editMode}
                    />
                  }
                  label="Kena Pajak"
                />
              )}
            />
          </Grid>
          <Grid>
            <Controller
              name="totalIncludesTax"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  disabled={!watch("taxable") || editMode}
                  control={
                    <Checkbox
                      {...field}
                      checked={field.value || false}
                      onChange={(e) => field.onChange(e.target.checked)}
                      disabled={!watch("taxable") || editMode}
                    />
                  }
                  label="Total Termasuk Pajak"
                />
              )}
            />
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

OtherSection.propTypes = {
  editMode: PropTypes.bool,
};
